<template>
	<el-main class="userdetail">
		<div class="mybread">
			<p><i class="el-icon-location"></i>当前位置：</p>
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item>其他管理</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/assest' }">物品管理</el-breadcrumb-item>
				<el-breadcrumb-item>发票管理</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<!-- 物品详情 -->
		<div class="base1">
			<h3 class="ntitle">物品详情</h3>
			<ul>
				<li>
					<p>
						<label>物品名称：</label><a>{{ form.asset_name }} {{ `- ${form.secondary_name}` }}</a>
					</p>
					<p>
						<label>物品编号：</label><a>{{ form.asset_code }}</a>
					</p>
					<p>
						<label>票面价格：</label><a>{{ form.asset_price }}</a>
					</p>
					<p>
						<label>购置日期：</label><a>{{ form.purchase_date }}</a>
					</p>
					<p>
						<label>备注：</label><a style="white-space: pre-wrap;">{{ form.remark }}</a>
					</p>
				</li>
				<li>
					<p>
						<label>序列码：</label><a>{{ form.serial_no ? form.serial_no : '暂无' }}</a>
					</p>
					<p>
						<label>物品归属：</label><a>{{ form.belong_type == '1' ? '行政' : '项目' }}</a>
					</p>
					<p>
						<label>购买数量：</label><a>{{ form.asset_count }}</a>
					</p>
				</li>
			</ul>
		</div>

		<!-- 发票管理 -->
		<div class="form myform">
			<el-form ref="form" :model="form" :rules="rules" label-width="150px" label-position="left">
				<!-- 发票信息 -->
				<div class="dividing-line">发票信息</div>
				<template>
					<ul class="anlist">
						<li v-for="(item, index) in form.invoiceList" :key="index">
							<div class="abox">
								<el-form-item label="发票代码：" prop="invoice_code">
									<el-col :span="12">
										<el-input placeholder="请输入" maxlength="100" v-model="item.invoice_code" clearable
											:disabled="(item.id && item.id != 0) && level != 1" />
									</el-col>
								</el-form-item>
								<el-form-item label="发票号码：" prop="invoice_no">
									<el-col :span="12">
										<el-input placeholder="请输入" maxlength="100" v-model="item.invoice_no" clearable
											:disabled="(item.id && item.id != 0) && level != 1" />
									</el-col>
								</el-form-item>
								<el-form-item label="发票金额：" prop="invoice_amount">
									<el-col :span="12">
										<el-input placeholder="请输入" maxlength="100" v-model="item.invoice_amount"
											@change="v => numberFn(v, item)" clearable :disabled="(item.id && item.id != 0) && level != 1" />
									</el-col>
								</el-form-item>
								<el-form-item label="发票日期：" prop="invoice_date">
									<el-col :span="5">
										<el-date-picker v-model="item.invoice_date" type="datetime" value-format="yyyy-MM-dd"
											:disabled="(item.id && item.id != 0) && level != 1" style="width: 100%;">
										</el-date-picker>
									</el-col>
								</el-form-item>
								<template>
									<ul class="anlist">
										<li v-for="(_it, _id) in item.atta_str" :key="_id">
											<div class="abox">
												<el-form-item :label='`发票附件${_id + 1}：`'>
													<!-- 选择文件 -->
													<el-col :span="3" v-if="(!_it.id && !_it.file_id)">
														<el-upload class="upload-demo" :ref="`$upFile${_id}`" action="#" :limit="1"
															:show-file-list="false" :auto-upload="false"
															accept=".pdf, .doc, .docx, .xls, .xlsx, .jpg, .png" :file-list="_it.flist"
															:on-change="(arg) => uploadFile(arg, item.atta_str, `$upFile${_id}`, _it, _id)">
															<el-button size="small" style="width: 100%">选择文件</el-button>
														</el-upload>
													</el-col>
													<!-- 文件预览及下载 -->
													<template v-if="_it.origin_name">
														<el-col :span="10">
															<el-col :span="18">
																<div class="origin-name">
																	{{ _it.origin_name }}</div>
															</el-col>
															<el-col :span="4">
																<el-link type="primary" style="margin-right:5px" :href="_it.httpFile"
																	target="_blank">查看</el-link>
															</el-col>
														</el-col>
													</template>
												</el-form-item>
											</div>
											<el-button class="bbtn" v-if="(!_it.id && !_it.file_id)" icon="el-icon-minus"
												@click="removeImage(item.atta_str, _id)" circle></el-button>
										</li>
										<el-button type="primary" style="margin: 0 0 15px 150px;" class="addbtn"
											@click="addImage(item.atta_str)">新增发票附件</el-button>
									</ul>
								</template>
							</div>
							<el-button class="abtn" icon="el-icon-minus" @click="removeInvoice(form.invoiceList, index)"
								circle></el-button>
						</li>
						<el-button type="primary" style="margin: 0 0 15px -5px;" class="addbtn"
							@click="addInvoice(form.invoiceList)">新增发票</el-button>
					</ul>
				</template>
			</el-form>
			<div class="btnarea">
				<el-col :span="10">
					<el-button @click="resetForm('form')">取消</el-button>
					<el-button type="primary" @click="submitForm('form')">保存</el-button>
				</el-col>
			</div>
		</div>
	</el-main>
</template>

<script>
// CodeToText
import * as api from '@/api'
import { timeFormat } from '@/utils/index.js'
import store from '@/store'
import { thousands } from '@/utils/index.js'
export default {
	name: 'assestAdd',
	data() {
		return {
			returnUrl: true, // 确实是否为手动按钮触发，还是右上角触发
			nodeLimtList: [],
			level: '',
			userId: '',
			uid: '',
			itemList: [],
			officeTypeList: [],
			userArr: {},
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() < Date.now() - 86400000; // 86400000 毫秒 = 1 天
				}
			},
			form: {
				asset_id: '', //物品ID（新增为空，编辑必填）
				category_id: '',
				belong_type: '1',
				is_consumable: '0',
				status: '1',
				invoiceList: [
					{ invoice_no: '', invoice_code: '', invoice_amount: '', invoice_date: '', atta_str: [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] }], }
				],
			},
			rules: {
				// client_company: [
				//   {
				//     required: true,
				//     message: '请输入客户公司名称',
				//     trigger: 'change',
				//   },
				// ],
				// brand: [
				//   {
				//     required: true,
				//     message: '请输入品牌',
				//     trigger: 'change',
				//   },
				// ],
			},
			dialogImageUrl: '',
			dialogVisible: false,
			disabled: false,
			del_invoice_list: [],
			del_invoice_atta_list: [],
			fileList: [
				{ origin_name: '', httpFile: '', file_id: '' }
			],
		}
	},
	computed: {

	},
	created() {
		this.query = this.$route.query
		this.getOfficeType().then(() => {
			this.query.id && this.getDetail(this.query.id)
		})
	},
	mounted() {

	},
	methods: {
		checkUrlFn() {
			// 获取当前URL的哈希部分
			const hash = window.location.hash;
			// 移除'#'字符
			const url = hash.substring(1);

			let postData = {
				url_path: url
			}
			api.checkLoginUrl(postData).then((res) => {
				if (res.status == 400) {
					this.$message({
						type: 'info',
						message: '暂无权限',
					})
					this.$router.push({
						path: `/home`
					});
				}
			})
		},
		checkNodeFn(menu_id) {
			let postData = {
				menu_id,
			}
			api.checkNode(postData).then((res) => {
				this.nodeLimtList = res.node_ids.split(',')
			})
		},
		NodeInclude(val) {
			return this.nodeLimtList.includes(val)
		},

		link(url) {
			this.$router.push(url)
		},

		getUserDetail(uid) {
			this.$fly
				.post('ApiStaffReimbursement_getStaffInfo.html', {
					uid: uid,
				})
				.then((res) => {
					this.userArr = res
				})
		},

		getOfficeType() {
			const that = this;
			return new Promise(function (resolve) {
				that.$fly.post("apiAsset_getAssetTypeDownList.html", {}).then((res) => {
					that.officeTypeList = res.length ? res : [];
					resolve(that.officeTypeList)
				});
			})
		},

		getDetail(id) {
			api.getAssetInfo({
				asset_id: id,
			}).then((res) => {
				const {
					asset_name,
					secondary_name,
					asset_code,
					serial_no,
					spec_model,
					asset_price,
					asset_count,
					purchase_date,
					belong_type,
					is_consumable,
					status,
					expired_count,
					remark,
					category,
					category_id,
					category_ids,
				} = res
				this.form = {
					...this.form,
					asset_name,
					secondary_name,
					asset_code,
					serial_no,
					spec_model,
					asset_price: thousands(asset_price),
					asset_count,
					purchase_date,
					belong_type,
					is_consumable,
					status,
					expired_count,
					remark,
					category,
					category_id,
					category_ids,
				}
				const atta_str = () => [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] }]
				this.form.invoiceList = res.invoiceList?.map((item) => {
					item.invoice_date = timeFormat(item.invoice_date)
					item.atta_str = item.fileList.length != 0 ? item.fileList : atta_str()
					return item
				})
				//防空情况
				if (res.invoiceList.length == 0) {
					this.form.invoiceList = [{ invoice_no: '', invoice_code: '', invoice_amount: '', invoice_date: '', atta_str: atta_str() }]
				}
				this.fileList = res.file_list?.slice(-1)
				console.log(this.form);
				this.getStoreFn()
			})
		},

		getStoreFn() {
			this.checkUrlFn()
			this.checkNodeFn('61')
			setTimeout(() => {
				//权限
				this.level = store.state.level
				this.userId = store.state.userId

			}, 200);
		},

		numberFn(v, item) {
			v = v.toString().replace(/,/g, "")
			item.invoice_amount = v
		},

		//选择文件
		uploadFile(file, fileList, ref, item, index) {
			let formData = new FormData();
			formData.append("file_arr", file.raw);
			formData.append("type", 7);
			api.uploadFile(formData)
				.then((res) => {
					fileList[index] = {
						...item,
						origin_name: res.origin_name,
						file_name: res.file_name,
						httpFile: res.httpFile,
					}
					this.$forceUpdate()
					this.$refs[ref][0].clearFiles();
				})
				.catch((err) => {
					console.log(err);
				});
		},

		addImage(arr) {
			console.log(arr);
			arr.push({ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] });
			this.$forceUpdate()
		},

		removeImage(arr, index) {
			// 修复：先声明 del_invoice_atta_list
			if (!this.del_invoice_atta_list) {
				this.del_invoice_atta_list = [];
			}
			if (arr[index].id) {
				this.del_invoice_atta_list.push(arr[index].id);
			}
			// 修复：直接修改原数组，而不是重新赋值
			arr.splice(index, 1);
			this.$forceUpdate()
		},

		addInvoice(arr) {
			arr.push({
				invoice_no: '',
				invoice_code: '',
				invoice_amount: '',
				invoice_date: '',
				atta_str: [{ origin_name: '', file_name: '', httpFile: '', id: '', flist: [] }],
			});
		},

		removeInvoice(arr, index) {
			this.del_invoice_list.push(arr[index].id);
			arr = arr.splice(index, 1);
		},

		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.addUpdateAsset()
				} else {
					console.log('error submit!!')
					return false
				}
			})
		},

		addUpdateAsset() {
			this.form.asset_id = this.query.id || ''
			this.form.option = this.form.asset_id ? '2' : '1'
			for (let i = 0; i < this.form.invoiceList.length; i++) {
				const element = this.form.invoiceList[i];
				if (!element.invoice_no) {
					this.$message.error('请正确填写所有的发票号码')
					return false
				}
			}
			// 替换掉id为invoice_id
			const $invoiceList = this.form.invoiceList?.map((item) => {
				Object.keys(item).forEach(key => {
					if (key == 'id') {
						item['invoice_id'] = item[key] || 0
						delete item[key]
					}
				})
				// 替换掉id为file_id
				item.atta_str = item.atta_str?.map((it) => {
					delete it.flist
					delete it.httpFile
					Object.keys(it).forEach(_key => {
						if (_key == 'id') {
							it['file_id'] = it[_key] || 0
							delete it[_key]
						}
					})
					return it
				})
				return item
			})
			this.form.invoiceList = $invoiceList
			// 替换掉id为file_id
			const $fileList = this.fileList?.map((item) => {
				Object.keys(item).forEach(key => {
					if (key == 'id') {
						item['file_id'] = item[key] || 0
						delete item[key]
					}
				})
				return item
			})
			const tempForm = JSON.parse(JSON.stringify(this.form))
			tempForm.img_str = JSON.stringify($fileList)
			tempForm.invoice_str = JSON.stringify(tempForm.invoiceList)
			delete tempForm.category
			delete tempForm.invoiceList
			const url = 'apiAsset_addUpdateAsset'
			this.$fly
				.post(url, {
					...tempForm,
					invoice_del: this.del_invoice_list.toString(),
				})
				.then(() => {
					this.$router.go(-1)
				})
		},

		resetForm(formName) {
			this.returnUrl = false
			this.$refs[formName].resetFields()
			this.$router.go(-1)
		},

		handleofficeChange(v) {
			const trueId = v[v.length - 1]
			this.form.category_id = trueId
			this.form.category_ids = v
		},

		beforeUpload(file) {
			this.fileList = []
			console.log(file)
			return true
		},

		imgchange(file) {
			file.id = this.fileList[0]?.id || this.fileList[0]?.file_id || ''
			this.fileList = []
			this.checkImg(file.url, file)
		},

		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.httpFile
			this.dialogVisible = true
		},

		uploadImage(dataURL, file) {
			api
				.uploadImage({
					img: dataURL,
					type: 7,
				})
				.then((res) => {
					const newfile = { file_id: file.id || '', origin_name: file.name, file_name: res.img_name, httpFile: res.httpImg }
					this.fileList = [newfile]
				})
		},
		checkImg(url, file) {
			const img = new Image()
			img.src = url
			if (img.complete) {
				console.log(
					'from:complete  :width:' + img.width + ',height:' + img.height
				)
			} else {
				img.onload = function () {
					let dataURL = ''
					let canvas = document.createElement('canvas')
					let width = img.width // 确保canvas的尺寸和图片一样
					let height = img.height
					canvas.width = width
					canvas.height = height
					canvas.getContext('2d').drawImage(img, 0, 0, width, height)
					dataURL = canvas.toDataURL('image/png')
					this.uploadImage(dataURL, file)
				}.bind(this)
			}
		},

	},
}
</script>

<style lang="scss" scoped>
.userdetail {
	.holiday-head {
		@extend %box;
		@extend %start;
		align-items: center;
		margin-bottom: 20px;
		padding: 30px 40px;
		position: relative;

		.holi-body {
			&.left {
				width: 70%;

				.hold-head-title {
					font: 600 28px/1 $font;
				}

				.hold-head-content {
					padding: 10px 0;

					div {
						font: 400 16px/1.5 $font;
					}
				}
			}

			&.right {
				width: 30%;

				.holiday-box {
					@extend %center;
					width: 180px;
					height: 80px;
					padding: 10px;
					color: #fff;
					border-radius: 10px;

					&.holi1 {
						background: #02a7f0;
					}

					&.holi2 {
						background: #ec808d;
					}

					&.holi3 {
						background: #81d3f8;
					}

					&.holi4 {
						background: #81d3f8;
					}

					&.holi5 {
						background: #70b603;
					}

					&.holi6 {
						background: #f59a23;
					}

					&.holi7 {
						background: #8400ff;
					}

					&.holi8 {
						background: #333333;
					}

					.box-title {
						font: 600 24px/1 $font;
						margin-bottom: 10px;
					}

					.box-info {
						font: 400 20px/1 $font;
					}
				}
			}
		}
	}

	.history {
		@extend %box;
		padding: 30px 40px;
	}

	.base1 {
		@extend %box;
		margin-bottom: 20px;
		padding: 30px 40px;
		position: relative;

		ul {
			@extend %start;
			color: #231f20;
			background: #f2f2f2;
			padding: 0 25px;
			border-radius: 20px;
			margin-bottom: 20px;
			position: relative;

			&:last-of-type {
				margin-bottom: 0;
			}

			li {
				width: 50%;
				font: 14px/3 $font;

				p {
					min-height: 42px;
					padding: 5px 0;
					@extend %start;

					label {
						width: 150px;
						white-space: nowrap;
						flex: none;
					}
				}
			}
		}
	}

	.btnarea {
		@extend %start;
		padding: 30px 0;
		position: relative;

		.left {
			width: 500px;
		}

		.right {
			width: 300px;
		}
	}

	.table {
		@extend %box;
		padding: 20px 40px;
		margin-bottom: 20px;
		position: relative;

		ul {
			@extend %start;
			color: #231f20;
			background: #fff;
			padding: 0 25px;
			border-radius: 20px;
			margin-bottom: 20px;
			position: relative;

			&:last-of-type {
				margin-bottom: 0;
			}

			li {
				width: 40%;
				font: 14px/3 $font;

				p {
					min-height: 42px;
					@extend %start;

					label {
						width: 150px;
						white-space: nowrap;
						flex: none;
					}
				}

				&:last-child {
					width: 60%;
					box-sizing: border-box;
					padding-left: 85px;
				}
			}
		}

		.for-title {
			font: 700 24px/1.5 $font;
			color: #444041;
		}

		.for {
			padding: 25px 0;

			&.grey {
				padding: 25px 20px;
				border-radius: 20px;
				background: #f2f2f2;
				margin-bottom: 20px;
			}

			ul {
				@extend %start;
				color: #231f20;
				background: #f2f2f2;
				padding: 0 25px;
				border-radius: 20px;
				margin-bottom: 20px;
				position: relative;

				&:last-of-type {
					margin-bottom: 0;
				}

				li {
					width: 40%;
					font: 14px/3 $font;

					p {
						height: 42px;
						@extend %start;

						label {
							width: 150px;
							white-space: nowrap;
							flex: none;
						}

						span {
							white-space: nowrap;
						}
					}

					&:last-child {
						width: 60%;
						box-sizing: border-box;
						padding-left: 85px;
					}
				}
			}

			.el-button {
				float: right;
				margin-bottom: 10px;
				position: relative;
			}
		}
	}

	.form.myform {
		padding-left: 100px;
	}

	.form {
		@extend %box;
		padding: 30px;
		margin-bottom: 20px;

		.anlist {
			padding: 0;
			flex-flow: column nowrap;

			li {
				position: relative;
				padding: 0;

				.abtn {
					position: absolute;
					top: 0;
					left: 65%;
				}

				.bbtn {
					position: absolute;
					top: 0;
					left: 60%;
				}
			}
		}
	}

	.formtitle {
		position: relative;
		left: -50px;
		margin-bottom: 30px;
		font-size: 28px;
		line-height: 48px;
		font-weight: 600;
	}
}

.holi-body {
	text-align: left;

	.hold-head-title {
		padding: 10px 0;
		font: 600 20px/1 $font;
	}

	.hold-head-content {
		padding: 10px 0;

		div {
			font: 400 16px/1.5 $font;
		}
	}

}

.dividing-line {
	font: 600 24px/1 $font;
	padding: 40px 0;
}
</style>
